import AttachmentItemFile from './AttachmentItemFile';
import Base64InlineImageFile from './Base64InlineImageFile';
import CloudFile from './CloudFile';
import LocalComputerFile from './LocalComputerFile';
import MailItemFile from './MailItemFile';
import UriFile from './UriFile';

type AttachmentFile =
    | LocalComputerFile
    | Base64InlineImageFile
    | CloudFile
    | MailItemFile
    | UriFile
    | AttachmentItemFile;

export default AttachmentFile;

export enum AttachmentFileType {
    Base64InlineImage,
    Cloud,
    Local,
    MailItem,
    Uri,
    AttachmentItem,
}

export interface AttachmentFileList {
    readonly length: number;
    readonly [index: number]: AttachmentFile;
}
